import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemTuDongBaoCao} from './datatable/list';
import { Danhmuc, DuLieuHeThong } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {MasterLayout} from 'layout';
import {Input, DropDownTreeMultipleSelect, DropDownTreeSelectOneElement, DatePicker, Text} from 'components/tt-forms/common';
import {
  DropDownChonLoaiQuyThongKe,
  DropDownChonLoaiKyThongKe,
  DropDownChonLoaiNamThongKe,
  DropDownChonLoaiThangThongKe
} from 'components/tt-forms';
import moment from 'moment';

class TuDongBaoCao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      popupViewCategory: false,
      addType: 0,

      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false,
      isValid: true,
      donViNhan: [],
      donViGui: null,
      listDonVi: [],
      listLoaiBaoCao: [],
      danhSachBaoCao: [],
      tenBaoCao: '',
      ngayBatDauBC: '',
      ngayKetThucBC: '',
      hanBaoCao: '',
      soNgayTuDongGui: 0,
      namBaoCao: '',
      thangBaoCao: '',
      quyBaoCao: '',
      kyBaoCao: 'THEO_QUY',
      idTTTP: ''
    };
  }

  componentDidMount() {
    this.getListData();
    this.getListDV();
    this.getLoaiBaoCao();
    this.checkDonVi();
  }

  checkDonVi() {
    Danhmuc.actions.getThamSo.request(null, {tuKhoa: 'CQQL_THANH_TRA_THANH_PHO'}).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({idTTTP: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : ''});
      }
    });
  }

  getListDV() {
    DuLieuHeThong.actions.getDonViThongKe.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          listDonVi: res.data._embedded.coQuanQuanLies
        })
      }
    });
  }
  getLoaiBaoCao() {
    Danhmuc.actions.getLoaiBaoCao.request().then(res => {
      if (res.data) {
        this.setState({listLoaiBaoCao: res.data});
      }
    });
  }

  onChange(name, e) {
    if (name == 'DonViNhan') {
      this.setState({
        donViNhan: e
      });
    } else if (name == 'danhSachBaoCao') {
      this.setState({
        danhSachBaoCao: e
      });
    } else {
      this.setState({
        [name]: e.target.value
      });
    }
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getCauHinhBaoCao.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.cauHinhBaoCaos,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.setState({pageData: {
      ...this.state.pageData,
      size: size,
      number: 0
    }}, () => {
      this.getListData();
    })
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  createCategory() {
    if(this.validateSubmitForm()){
      let params = {
        tenBaoCao: this.state.tenBaoCao
      };
      let dsBaoCao = []
      this.state.danhSachBaoCao.forEach(item => {
        dsBaoCao = [...dsBaoCao, item.value];
      });
      params.danhSachBaoCao = dsBaoCao.join(';');
      params.ngayBatDauBC = moment(this.state.ngayBatDauBC).add(7, 'hours').toISOString();
      params.ngayKetThucBC = moment(this.state.ngayKetThucBC).add(7, 'hours').toISOString();
      params.hanBaoCao = this.state.hanBaoCao ? moment(this.state.hanBaoCao).add(7, 'hours').toISOString() : '';
      params.kyBaoCao = this.state.kyBaoCao || '';
      params.namBaoCao = this.state.namBaoCao || '';
      params.soNgayTuDongGui = this.state.soNgayTuDongGui || 0;
      params.donViGui = {id: this.state.donViGui};
      params.donViNhans = [];
      this.state.donViNhan.map(item => {
        params.donViNhans = [...params.donViNhans, {id: item.value}];
      });
      if (this.state.kyBaoCao == 'THEO_QUY') {
        params.quyBaoCao = this.state.quyBaoCao;
      }
      if (this.state.kyBaoCao == 'THEO_THANG') {
        params.thangBaoCao = this.state.thangBaoCao;
      }

      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        Danhmuc.actions.updateCauHinhBaoCao.request({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        Danhmuc.actions.postCauHinhBaoCao.request('',params).then(res => {
          this.getListData();
          this.closeDialog();
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
    }
  }

  handlePageClick(page) {
    this.setState({pageData: {
      ...this.state.pageData,
      number: page.selected
    }}, () => {
      this.getListData();
    })
  }

  handleDelete(categoryId) {
     if(categoryId){
      this.setState({buttonLoading: true});
      Danhmuc.actions.deleteCauHinhBaoCao.request({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
      });
     }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  openDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
  }

  closeDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    //
  }
  openView() {
    this.setState({popupViewCategory: !this.state.popupViewCategory});
  }

  closeView() {
    this.setState({popupViewCategory: !this.state.popupViewCategory});
  }

  openAddNewCategory() {
    this.openDialog();
    this.setState({
      addType: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      donViNhan: [],
      donViGui: this.state.idTTTP || null,
      danhSachBaoCao: [],
      tenBaoCao: '',
      ngayBatDauBC: '',
      ngayKetThucBC: '',
      hanBaoCao: '',
      soNgayTuDongGui: 0,
      namBaoCao: '',
      thangBaoCao: '',
      quyBaoCao: '',
      kyBaoCao: 'THEO_QUY',
      isValid: true
    });
  }

  viewUpdateCategory(item) {
    this.openView();
    let dvNhan = [];
    dvNhan = item.donViNhanInfo.map(item => ' ' + item.ten);

    let arrDSBC = [];
    const dsBaoCao = item.danhSachBaoCao.split(';');
    dsBaoCao.forEach(itemBC => {
      let dsLoaiBaoCao = [];
      this.state.listLoaiBaoCao.forEach(itemLBC => {
        if (itemLBC.giaTri === itemBC) {
          dsLoaiBaoCao.push({label: itemLBC.ten, value: itemLBC.giaTri});
        }
      });
      arrDSBC = arrDSBC.concat(dsLoaiBaoCao);
    });

    DuLieuHeThong.actions.getLoaiKyThongKe.request().then(res => {
      if (res && res.data) {
        let check = res.data.findIndex(items => items.giaTri === item.kyBaoCao);
          if (check !== -1) {
            this.setState({kyBaoCao: res.data[check].ten});
          }
        }
    });

    this.setState({
      addType:2,
      donViNhan: dvNhan,
      donViGui: item.donViGuiInfo ? item.donViGuiInfo.ten : null,
      danhSachBaoCao: arrDSBC,
      tenBaoCao: item.tenBaoCao,
      ngayBatDauBC: new Date(item.ngayBatDauBC),
      ngayKetThucBC: new Date(item.ngayKetThucBC),
      hanBaoCao: item.hanBaoCao ? new Date(item.hanBaoCao) : '',
      soNgayTuDongGui: item.soNgayTuDongGui || 0,
      namBaoCao: item.namBaoCao || '',
      thangBaoCao: item.thangBaoCao || '',
      quyBaoCao: item.quyBaoCao || '',
      kyBaoCao: item.kyBaoCao || 'THEO_QUY',
      categoryId: item.cauHinhBaoCaoId,
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.openDialog();
    let dvNhan = [];
    item.donViNhanInfo.map(item => {
      dvNhan = [...dvNhan, {label: item.ten, value: item.id}]
    });
    let arrDSBC = [];
    item.danhSachBaoCao.split(';').forEach(item => {
      let findItem = this.state.listLoaiBaoCao.filter(item1 => {
        return item1.giaTri == item;
      }).map(item1 => {
        return item1 = {label: item1.ten, value: item1.giaTri}
      });
      if (findItem.length > 0) {
        arrDSBC = [...arrDSBC, ...findItem]
      }
    });

    this.setState({
      addType:2,
      donViNhan: dvNhan,
      donViGui: item.donViGuiInfo ? item.donViGuiInfo.id : null,
      danhSachBaoCao: arrDSBC,
      tenBaoCao: item.tenBaoCao,
      ngayBatDauBC: new Date(item.ngayBatDauBC),
      ngayKetThucBC: new Date(item.ngayKetThucBC),
      hanBaoCao: item.hanBaoCao ? new Date(item.hanBaoCao) : '',
      soNgayTuDongGui: item.soNgayTuDongGui || 0,
      namBaoCao: item.namBaoCao || '',
      thangBaoCao: item.thangBaoCao || '',
      quyBaoCao: item.quyBaoCao || '',
      kyBaoCao: item.kyBaoCao || 'THEO_QUY',
      categoryId: item.cauHinhBaoCaoId,
      isValid: true
    });
  }

  render() {
    let danhSachBC = [];
    if (this.state.danhSachBaoCao) {
      danhSachBC = this.state.danhSachBaoCao.map(item => ' ' + item.label);
    }
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Cấu hình báo cáo</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('CAUHINHBAOCAO_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <Search parents={this}/>
            <DataTable
              header = {header.categoryGroup.cauHinhBaoCao}
              dataList={this.state.data}
              pageData={this.state.pageData}
              parent= {this}
              hideExport
              tableLoading = {this.state.tableLoading}
            >
              <RowItemTuDongBaoCao/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupViewCategory}
            onClose={this.closeView.bind(this)}
            title='Thông tin cấu hình báo cáo'
            iconName="add-new"
            className="panel-popup wrap-block">
            <div className="pt-dialog-body">
              <Text className='col-100' label='Tên báo cáo' value={this.state.tenBaoCao}/>
              <Text className='col-100' label='Danh sách biểu mẫu' value={danhSachBC}/>
              <Text className='col-25' label='Kỳ báo cáo' value={this.state.kyBaoCao}/>
              <Text className='col-25' label='Năm báo cáo' value={this.state.namBaoCao}/>
              {
                this.state.kyBaoCao == 'THEO_QUY' &&
                <Text className='col-25' label='Quý báo cáo' value={this.state.quyBaoCao}/>
              }
              {
                this.state.kyBaoCao == 'THEO_THANG' &&
                <Text className='col-25' label='Tháng báo cáo' value={this.state.thangBaoCao}/>
              }
              <Text className='col-25' label='Ngày bắt đầu báo cáo' value={moment(this.state.ngayBatDauBC).format('DD/MM/YYYY')}/>
              <Text className='col-25' label='Ngày kết thúc báo cáo' value={moment(this.state.ngayKetThucBC).format('DD/MM/YYYY')}/>
              <Text className='col-25' label='Hạn báo cáo' value={moment(this.state.hanBaoCao).format('DD/MM/YYYY')}/>
              <Text className='col-25' label='Số ngày tự động gửi' value={this.state.soNgayTuDongGui}/>

              <Text className='col-100' label='Đơn vị gửi' value={this.state.donViGui}/>
              <Text className='col-100' label='Đơn vị nhận' value={this.state.donViNhan}/>
            </div>
            <div className="pt-dialog-footer mb18">
                <Link onClick={this.closeView.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
            </div>
          </Dialog>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.closeDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa cấu hình báo cáo' : 'Thêm mới cấu hình báo cáo'}
            iconName="add-new"
            className="panel-popup wrap-block">
            <div className="pt-dialog-body">
              <Input className="col-100" label="Tên báo cáo" value={this.state.tenBaoCao} bindValidator={this} channel="formTaoDon" require maxLength={255} onChange={this.onChange.bind(this, 'tenBaoCao')}/>
              <DropDownTreeMultipleSelect disable className='col-100' label="Danh sách biểu mẫu" bindValidator={this} channel="formTaoDon" require dataOptions={this.state.listLoaiBaoCao} dataSelected={this.state.danhSachBaoCao} onChange={this.onChange.bind(this, 'danhSachBaoCao')} propertyParent='giaTri'/>

              <DropDownChonLoaiKyThongKe className='col-25' bindValidator={this} channel="formTaoDon" require placeholder={null} onChange={this.onChange.bind(this, 'kyBaoCao')} selectedValue={this.state.kyBaoCao}/>


              <DropDownChonLoaiNamThongKe className='col-25' bindValidator={this} channel="formTaoDon" require onChange={this.onChange.bind(this, 'namBaoCao')} selectedValue={this.state.namBaoCao}/>

              {
                this.state.kyBaoCao == 'THEO_QUY' &&
                <DropDownChonLoaiQuyThongKe className='col-25' bindValidator={this} channel="formTaoDon" require onChange={this.onChange.bind(this, 'quyBaoCao')} selectedValue={this.state.quyBaoCao}/>
              }
              {
                this.state.kyBaoCao == 'THEO_THANG' &&
                <DropDownChonLoaiThangThongKe className='col-25' bindValidator={this} channel="formTaoDon" require onChange={this.onChange.bind(this, 'thangBaoCao')} selectedValue={this.state.thangBaoCao}/>
              }
              <DatePicker className="col-25" label="Ngày bắt đầu báo cáo" endDate={ this.state.ngayKetThucBC } bindValidator={this} channel="formTaoDon" require value={this.state.ngayBatDauBC} onChange={this.handleChangeDate.bind(this, 'ngayBatDauBC')} name="ngayBatDauBC" min/>
              <DatePicker className="col-25" label="Ngày kết thúc báo cáo" bindValidator={this} channel="formTaoDon" startDate={ this.state.ngayBatDauBC } endDate={ this.state.hanBaoCao } require value={this.state.ngayKetThucBC} onChange={this.handleChangeDate.bind(this, 'ngayKetThucBC')} name="ngayKetThucBC"/>
              <DatePicker className="col-25" label="Hạn báo cáo" startDate={ this.state.ngayKetThucBC } bindValidator={this} channel="formTaoDon" require value={this.state.hanBaoCao} onChange={this.handleChangeDate.bind(this, 'hanBaoCao')} name="hanBaoCao"/>
              <Input className="col-25" label="Số ngày tự động gửi" bindValidator={this} channel="formTaoDon" require value={this.state.soNgayTuDongGui}  maxLength={255} onChange={this.onChange.bind(this, 'soNgayTuDongGui')}/>

              <DropDownTreeSelectOneElement label="Đơn vị gửi" className='col-100' bindValidator={this} channel="formTaoDon" require dataOptions={this.state.listDonVi} value={this.state.donViGui} onChange={this.onChange.bind(this, 'donViGui')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
              <DropDownTreeMultipleSelect className='col-100' label="Đơn vị nhận" bindValidator={this} channel="formTaoDon" require dataOptions={this.state.listDonVi} dataSelected={this.state.donViNhan} onChange={this.onChange.bind(this, 'DonViNhan')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId'/>
            </div>
            <div className="pt-dialog-footer mb18">
                <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                  <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
                </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

TuDongBaoCao.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default TuDongBaoCao;



// WEBPACK FOOTER //
// ./src/components/modules/category/TuDongBaoCao.jsx